import { ILibraryComponent, ILibraryComponentList } from '../../components/library/types';

import IntroLib from './Intro/Library.vue';

import QuoteLib from './Quote/Library.vue';
import QuotePage from './Quote/Example.vue';
import HighlightedTextLib from './HighlightedText/Library.vue';
import HighlightedTextPage from './HighlightedText/Example.vue';
import StatisticLib from './Statistic/Library.vue';
import StatisticPage from './Statistic/Example.vue';
import HeadingsLib from './Headings/Library.vue';
import HeadingsPage from './Headings/Example.vue';
import AlertsLib from './Alerts/Library.vue';
import InformationAlertPage from './Alerts/InformationAlert.vue';
import NegativeAlertPage from './Alerts/NegativeAlert.vue';
import PositiveAlertPage from './Alerts/PositiveAlert.vue';
import ListsLib from './Lists/Library.vue';
import StdListPage from './Lists/StandardList.vue';
import PosListPage from './Lists/PositiveList.vue';
import NegListPage from './Lists/NegativeList.vue';
import CheckboxLib from './Checkbox/Library.vue';
import CheckboxPage from './Checkbox/Example.vue';
import RadiolistLib from './Radiolist/Library.vue';
import RadiolistPage from './Radiolist/Example.vue';
import TextareaLib from './Textarea/Library.vue';
import TextareaPage from './Textarea/Example.vue';
import TextfieldLib from './Textfield/Library.vue';
import TextfieldPage from './Textfield/Example.vue';
import HeaderLib from './Header/Library.vue';
import DefHeaderPage from './Header/DefaultHeader.vue';
import TransHeaderPage from './Header/TransactionalHeader.vue';
import LogoHeaderPage from './Header/Logo.vue';
import SearchHeaderPage from './Header/Search.vue';
import FooterLib from './Footer/Library.vue';
import FooterPage from './Footer/Example.vue';

/*import Placeholder from './UIExamplePlaceholder.vue';*/

const components: ILibraryComponentList = {
    categories: [
        {
            id: 'Intro',
            title: 'Intoduction',
            components: [
                { id: 'IntroNotes', title: '', libraryComponent: IntroLib }
            ]
        },
        {
            id: 'Content',
            title: 'Content Display',
            components: [
                { id: 'Quote', title: 'Quote', libraryComponent: QuoteLib, fullPageComponent: QuotePage },
                { id: 'HighlightedText', title: 'Highlighted Text', libraryComponent: HighlightedTextLib, fullPageComponent: HighlightedTextPage },
                { id: 'Statistic', title: 'Statistic', libraryComponent: StatisticLib, fullPageComponent: StatisticPage },
                { id: 'Headings', title: 'Headings', libraryComponent: HeadingsLib, fullPageComponent: HeadingsPage },
                { id: 'Alerts', title: 'Alerts', libraryComponent: AlertsLib },
                { id: 'AlertInformation', title: 'Alert', fullPageComponent: InformationAlertPage },
                { id: 'AlertNegative', title: 'Alert', fullPageComponent: NegativeAlertPage },
                { id: 'AlertPositive', title: 'Alert', fullPageComponent: PositiveAlertPage },
                { id: 'Lists', title: 'Lists', libraryComponent: ListsLib },
                { id: 'ListStandard', title: 'Standard List', fullPageComponent: StdListPage },
                { id: 'ListPositive', title: 'Positive List', fullPageComponent: PosListPage },
                { id: 'ListNegative', title: 'Negative List', fullPageComponent: NegListPage }
            ]
        },
        {
            id: 'Form',
            title: 'Form Inputs',
            components: [
                { id: 'Checkbox', title: 'Checkbox', libraryComponent: CheckboxLib, fullPageComponent: CheckboxPage },
                { id: 'Radiolist', title: 'Radiolist', libraryComponent: RadiolistLib, fullPageComponent: RadiolistPage },
                { id: 'Textarea', title: 'Textarea', libraryComponent: TextareaLib, fullPageComponent: TextareaPage },
                { id: 'Textfield', title: 'Textfield', libraryComponent: TextfieldLib, fullPageComponent: TextfieldPage }
            ]
        },
        {
            id: 'Navigation',
            title: 'Navigation',
            components: [
                { id: 'Header', title: 'Header', libraryComponent: HeaderLib },
                { id: 'HeaderDefault', title: 'Default Header', fullPageComponent: DefHeaderPage },
                { id: 'HeaderTransactional', title: 'Transactional Header', fullPageComponent: TransHeaderPage },
                { id: 'HeaderLogo', title: 'Header Logo', fullPageComponent: LogoHeaderPage },
                { id: 'HeaderSearch', title: 'Header Search', fullPageComponent: SearchHeaderPage },
                { id: 'Footer', title: 'Footer', libraryComponent: FooterLib, fullPageComponent: FooterPage }
            ]
        }
    ],
    getAllComponents(): ILibraryComponent[] {
        var comps: ILibraryComponent[] = [];
        return this.categories?.reduce((a, b) => a.concat(b.components), comps);
    }
};

export default components;